import { useGetFilesQuery } from "services/file-api";
import type { FileType } from "types/DataTypes";
import { useToken } from "utils/context";

type RecentlyViewedFile = {
  id: number;
  name: string;
  claimant_name: string;
};

export const useRecentlyViewedFiles = () => {
  const { accessToken } = useToken();

  const {
    data: filesData,
    isLoading,
    error,
  } = useGetFilesQuery(
    {
      filters: {
        recently_viewed: true,
        limit: 5, // show top 5 recently viewed in navigation
      },
    },
    {
      skip: !accessToken,
    },
  );

  const recentlyViewedFiles: RecentlyViewedFile[] =
    filesData?.results?.map((file: FileType) => ({
      id: file.id,
      name: `#${file.id}`,
      claimant_name:
        file.claimants && file.claimants.length > 0
          ? `${file.claimants[0].first_name} ${file.claimants[0].last_name}`
          : "No Claimant",
    })) || [];

  return {
    recentlyViewedFiles,
    isLoading,
    error,
  };
};
